// extracted by mini-css-extract-plugin
export var aiStarIcon = "_j4-2";
export var container = "_j4-4";
export var dismissButton = "_j4-3";
export var hasPaddingBottom = "_j4-6";
export var last = "_j4-e";
export var scrollbarThumb = "_j4-c";
export var scrollbarTrack = "_j4-b";
export var selected = "_j4-9";
export var spin = "_j4-1";
export var spinning = "_j4-0";
export var suggestionItem = "_j4-d";
export var suggestionsPanel = "_j4-5";
export var tonePill = "_j4-8";
export var tonesContainer = "_j4-7";
export var unselected = "_j4-a";